<template>
    <div class="page">
        <!-- 增加装饰元素提升层次感 -->
        <div class="background-decoration"></div>

        <div class="main">
            <div class="top-logo">
                <img src="@/assets/wen/logo3.png" alt="">
            </div>
            <div class="title">欢迎登录</div>
            <van-cell-group inset>
                <div class="ipt-title">昵称</div>
                <van-field v-model="myNikeName" clearable placeholder="请输入您的昵称">
                    <template #left-icon>
                        <img src="@/assets/wen/dsh.png" />
                    </template>
                </van-field>

                <div class="ipt-title">手机号</div>
                <van-field v-model="phone" clearable placeholder="请输入购买手机号">
                    <template #left-icon>
                        <img src="@/assets/wen/phone.png" />
                    </template>
                </van-field>

                <div class="ipt-title">验证码</div>
                <van-field v-model="sms" clearable placeholder="请输入手机号验证码">
                    <template #left-icon>
                        <img src="@/assets/wen/yzm.png" />
                    </template>
                    <van-button slot="button" type="primary" size="small" :disabled="smsFlag" class="codeBtn"
                        @click="getSmsCode">{{ btnTxt }}</van-button>
                </van-field>


            </van-cell-group>
            <van-button color="#000" class="login-btn" @click="toLogin">登录/注册</van-button>
        </div>

    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/user'
export default {
    data() {
        return {
            smsFlag: false,
            btnTxt: '发送验证码',
            myNikeName: '',
            phone: '',
            sms: '',
            checked: false,
        }
    },
    methods: {
        getSmsCode() {
            if (!this.phone) {
                Toast.fail('请输入手机号！')
                return
            }
            var data = {
                userPhone: this.phone
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if (res.data.code == 200) {
                    var n = 60;
                    this.btnTxt = '重新发送' + n + 's';
                    let timer = window.setInterval(() => {
                        n--;
                        this.btnTxt = '重新发送' + n + 's';
                        if (n < 1) {
                            window.clearInterval(timer);
                            this.btnTxt = '获取验证码';
                        }
                    }, 1000)
                    Toast.success("发送成功");
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        },

        toLogin() {
            if (!this.myNikeName) {
                Toast.fail('请输入昵称！')
                return
            }
            if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.phone))) {
                Toast.fail('请填写正确的手机号')
                return
            }

            var data = {
                userPhone: this.phone,
                smsCode: this.sms
            }
            wxRequest("applyChangeSim/checkoutPhone", data, "post").then(res => {
                if (res.data.code == 200) {
                    localStorage.setItem('myNikeName', this.myNikeName);
                    localStorage.setItem('myLoginPhone', this.phone);
                    Dialog.confirm({
                        title: "温馨提示",
                        message: "注册成功！后续可用此账号直接查询订单",
                    }).then(() => {
                        this.$router.push({ path: '/buy/userInfo' });
                    }).catch(() => {
                        this.$router.push({ path: '/buy/userInfo' });
                    });
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })

        },



    }
}
</script>

<style lang="less" scoped>
.page {
    /* 替换为渐变色背景 */
    background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
    height: 100vh;
    position: relative;
    overflow: hidden;

    /* 背景装饰元素 */
    .background-decoration {
        position: absolute;
        width: 600px;
        height: 600px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        top: -200px;
        right: -200px;
        filter: blur(60px);
        z-index: 0;
    }

    .main {
        background-color: rgba(255, 255, 255, 0.85);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        padding: 25px;
        max-width: 400px;
        margin: 50px auto;
        width: 90%;
        border-radius: 16px;
        position: relative;
        z-index: 1;

        .top-logo {
            padding-top: 68px;
            text-align: center;
            margin: auto;

            img {
                width: 77px;
            }
        }

        .title {
            font-size: 36px;
            padding: 11px 0;
            font-family: Medium, sans-serif;
            color: #111517;
            font-weight: bold;
            text-align: center;
        }

        .van-cell-group {
            margin-top: 20px;

            &::after {
                border: none;
            }

            .ipt-title {
                font-family: Regular, sans-serif;
                color: #111517;
                font-size: 18px;
                margin-bottom: 14px;
            }

            .van-cell {
                border: 1px solid #86868b;
                margin-bottom: 17px;
                border-radius: 9px;
                padding: 10px;
                background-color: #fff;
                position: relative;
                align-items: center;

                ::v-deep .van-field__left-icon {
                    width: 27px;

                    img {
                        width: 100%;
                        margin-top: 2px;
                    }
                }

                ::v-deep .van-cell__value {
                    line-height: 34px;
                }

                ::v-deep .van-field__control {
                    height: 44px;
                }
            }
        }

        .login-btn {
            padding: 14px;
            color: #fff;
            text-align: center;
            border-radius: 8px;
            margin-top: 55px;
            width: 100%;
        }
    }

    .rules {
        color: #a2a7ad;
        margin-top: 36px;
        text-align: center;

        .van-radio-group--horizontal {
            justify-content: center;

            ::v-deep.van-radio__label {
                color: #666;

                span {
                    color: #000;
                }
            }
        }
    }
}
</style>